/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CognitiveNormCto } from '../models/cognitive-norm-cto';
import { DemoAccountDataCto } from '../models/demo-account-data-cto';
import { DemoAccountDataExportCto } from '../models/demo-account-data-export-cto';
import { DemoAccountDataSummaryCto } from '../models/demo-account-data-summary-cto';
import { DemoAccountDataVersionCto } from '../models/demo-account-data-version-cto';
import { DemoDataPublishResultCto } from '../models/demo-data-publish-result-cto';
import { DemoDataValidationResultCto } from '../models/demo-data-validation-result-cto';
import { exportDemoAccountDataAsync$Json } from '../fn/demo-account-data/export-demo-account-data-async-json';
import { ExportDemoAccountDataAsync$Json$Params } from '../fn/demo-account-data/export-demo-account-data-async-json';
import { exportDemoAccountDataAsync$Plain } from '../fn/demo-account-data/export-demo-account-data-async-plain';
import { ExportDemoAccountDataAsync$Plain$Params } from '../fn/demo-account-data/export-demo-account-data-async-plain';
import { getDemoAccountDataAsync$Json } from '../fn/demo-account-data/get-demo-account-data-async-json';
import { GetDemoAccountDataAsync$Json$Params } from '../fn/demo-account-data/get-demo-account-data-async-json';
import { getDemoAccountDataAsync$Plain } from '../fn/demo-account-data/get-demo-account-data-async-plain';
import { GetDemoAccountDataAsync$Plain$Params } from '../fn/demo-account-data/get-demo-account-data-async-plain';
import { getDemoAccountDataHistoryAsync$Json } from '../fn/demo-account-data/get-demo-account-data-history-async-json';
import { GetDemoAccountDataHistoryAsync$Json$Params } from '../fn/demo-account-data/get-demo-account-data-history-async-json';
import { getDemoAccountDataHistoryAsync$Plain } from '../fn/demo-account-data/get-demo-account-data-history-async-plain';
import { GetDemoAccountDataHistoryAsync$Plain$Params } from '../fn/demo-account-data/get-demo-account-data-history-async-plain';
import { getDemoAccountDataSummariesAsync$Json } from '../fn/demo-account-data/get-demo-account-data-summaries-async-json';
import { GetDemoAccountDataSummariesAsync$Json$Params } from '../fn/demo-account-data/get-demo-account-data-summaries-async-json';
import { getDemoAccountDataSummariesAsync$Plain } from '../fn/demo-account-data/get-demo-account-data-summaries-async-plain';
import { GetDemoAccountDataSummariesAsync$Plain$Params } from '../fn/demo-account-data/get-demo-account-data-summaries-async-plain';
import { getDemoAccountDataVersionAsync$Json } from '../fn/demo-account-data/get-demo-account-data-version-async-json';
import { GetDemoAccountDataVersionAsync$Json$Params } from '../fn/demo-account-data/get-demo-account-data-version-async-json';
import { getDemoAccountDataVersionAsync$Plain } from '../fn/demo-account-data/get-demo-account-data-version-async-plain';
import { GetDemoAccountDataVersionAsync$Plain$Params } from '../fn/demo-account-data/get-demo-account-data-version-async-plain';
import { getDemoCognitiveNormsAsync$Json } from '../fn/demo-account-data/get-demo-cognitive-norms-async-json';
import { GetDemoCognitiveNormsAsync$Json$Params } from '../fn/demo-account-data/get-demo-cognitive-norms-async-json';
import { getDemoCognitiveNormsAsync$Plain } from '../fn/demo-account-data/get-demo-cognitive-norms-async-plain';
import { GetDemoCognitiveNormsAsync$Plain$Params } from '../fn/demo-account-data/get-demo-cognitive-norms-async-plain';
import { importDemoAccountDataAsync$Json } from '../fn/demo-account-data/import-demo-account-data-async-json';
import { ImportDemoAccountDataAsync$Json$Params } from '../fn/demo-account-data/import-demo-account-data-async-json';
import { importDemoAccountDataAsync$Plain } from '../fn/demo-account-data/import-demo-account-data-async-plain';
import { ImportDemoAccountDataAsync$Plain$Params } from '../fn/demo-account-data/import-demo-account-data-async-plain';
import { publishDemoAccountDataAsync$Json } from '../fn/demo-account-data/publish-demo-account-data-async-json';
import { PublishDemoAccountDataAsync$Json$Params } from '../fn/demo-account-data/publish-demo-account-data-async-json';
import { publishDemoAccountDataAsync$Plain } from '../fn/demo-account-data/publish-demo-account-data-async-plain';
import { PublishDemoAccountDataAsync$Plain$Params } from '../fn/demo-account-data/publish-demo-account-data-async-plain';
import { restoreDemoAccountDataVersionAsync$Json } from '../fn/demo-account-data/restore-demo-account-data-version-async-json';
import { RestoreDemoAccountDataVersionAsync$Json$Params } from '../fn/demo-account-data/restore-demo-account-data-version-async-json';
import { restoreDemoAccountDataVersionAsync$Plain } from '../fn/demo-account-data/restore-demo-account-data-version-async-plain';
import { RestoreDemoAccountDataVersionAsync$Plain$Params } from '../fn/demo-account-data/restore-demo-account-data-version-async-plain';
import { validateDemoAccountDataAsync$Json } from '../fn/demo-account-data/validate-demo-account-data-async-json';
import { ValidateDemoAccountDataAsync$Json$Params } from '../fn/demo-account-data/validate-demo-account-data-async-json';
import { validateDemoAccountDataAsync$Plain } from '../fn/demo-account-data/validate-demo-account-data-async-plain';
import { ValidateDemoAccountDataAsync$Plain$Params } from '../fn/demo-account-data/validate-demo-account-data-async-plain';

@Injectable({ providedIn: 'root' })
export class DemoAccountDataService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getDemoAccountDataSummariesAsync()` */
  static readonly GetDemoAccountDataSummariesAsyncPath = '/demo-account-data';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoAccountDataSummariesAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataSummariesAsync$Plain$Response(params?: GetDemoAccountDataSummariesAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DemoAccountDataSummaryCto>>> {
    return getDemoAccountDataSummariesAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoAccountDataSummariesAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataSummariesAsync$Plain(params?: GetDemoAccountDataSummariesAsync$Plain$Params, context?: HttpContext): Observable<Array<DemoAccountDataSummaryCto>> {
    return this.getDemoAccountDataSummariesAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DemoAccountDataSummaryCto>>): Array<DemoAccountDataSummaryCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoAccountDataSummariesAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataSummariesAsync$Json$Response(params?: GetDemoAccountDataSummariesAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DemoAccountDataSummaryCto>>> {
    return getDemoAccountDataSummariesAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoAccountDataSummariesAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataSummariesAsync$Json(params?: GetDemoAccountDataSummariesAsync$Json$Params, context?: HttpContext): Observable<Array<DemoAccountDataSummaryCto>> {
    return this.getDemoAccountDataSummariesAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DemoAccountDataSummaryCto>>): Array<DemoAccountDataSummaryCto> => r.body)
    );
  }

  /** Path part for operation `getDemoCognitiveNormsAsync()` */
  static readonly GetDemoCognitiveNormsAsyncPath = '/demo-account-data/cognitive-norms';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoCognitiveNormsAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoCognitiveNormsAsync$Plain$Response(params?: GetDemoCognitiveNormsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CognitiveNormCto>>> {
    return getDemoCognitiveNormsAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoCognitiveNormsAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoCognitiveNormsAsync$Plain(params?: GetDemoCognitiveNormsAsync$Plain$Params, context?: HttpContext): Observable<Array<CognitiveNormCto>> {
    return this.getDemoCognitiveNormsAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CognitiveNormCto>>): Array<CognitiveNormCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoCognitiveNormsAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoCognitiveNormsAsync$Json$Response(params?: GetDemoCognitiveNormsAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CognitiveNormCto>>> {
    return getDemoCognitiveNormsAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoCognitiveNormsAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoCognitiveNormsAsync$Json(params?: GetDemoCognitiveNormsAsync$Json$Params, context?: HttpContext): Observable<Array<CognitiveNormCto>> {
    return this.getDemoCognitiveNormsAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CognitiveNormCto>>): Array<CognitiveNormCto> => r.body)
    );
  }

  /** Path part for operation `getDemoAccountDataAsync()` */
  static readonly GetDemoAccountDataAsyncPath = '/demo-account-data/{demoDataType}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoAccountDataAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataAsync$Plain$Response(params: GetDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataCto>> {
    return getDemoAccountDataAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoAccountDataAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataAsync$Plain(params: GetDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<DemoAccountDataCto> {
    return this.getDemoAccountDataAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoAccountDataCto>): DemoAccountDataCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoAccountDataAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataAsync$Json$Response(params: GetDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataCto>> {
    return getDemoAccountDataAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoAccountDataAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataAsync$Json(params: GetDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<DemoAccountDataCto> {
    return this.getDemoAccountDataAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoAccountDataCto>): DemoAccountDataCto => r.body)
    );
  }

  /** Path part for operation `publishDemoAccountDataAsync()` */
  static readonly PublishDemoAccountDataAsyncPath = '/demo-account-data/{demoDataType}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishDemoAccountDataAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publishDemoAccountDataAsync$Plain$Response(params: PublishDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
    return publishDemoAccountDataAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishDemoAccountDataAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publishDemoAccountDataAsync$Plain(params: PublishDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<DemoDataPublishResultCto> {
    return this.publishDemoAccountDataAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoDataPublishResultCto>): DemoDataPublishResultCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `publishDemoAccountDataAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publishDemoAccountDataAsync$Json$Response(params: PublishDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
    return publishDemoAccountDataAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `publishDemoAccountDataAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  publishDemoAccountDataAsync$Json(params: PublishDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<DemoDataPublishResultCto> {
    return this.publishDemoAccountDataAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoDataPublishResultCto>): DemoDataPublishResultCto => r.body)
    );
  }

  /** Path part for operation `validateDemoAccountDataAsync()` */
  static readonly ValidateDemoAccountDataAsyncPath = '/demo-account-data/{demoDataType}/validate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateDemoAccountDataAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  validateDemoAccountDataAsync$Plain$Response(params: ValidateDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataValidationResultCto>> {
    return validateDemoAccountDataAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateDemoAccountDataAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  validateDemoAccountDataAsync$Plain(params: ValidateDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<DemoDataValidationResultCto> {
    return this.validateDemoAccountDataAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoDataValidationResultCto>): DemoDataValidationResultCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateDemoAccountDataAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  validateDemoAccountDataAsync$Json$Response(params: ValidateDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataValidationResultCto>> {
    return validateDemoAccountDataAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateDemoAccountDataAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  validateDemoAccountDataAsync$Json(params: ValidateDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<DemoDataValidationResultCto> {
    return this.validateDemoAccountDataAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoDataValidationResultCto>): DemoDataValidationResultCto => r.body)
    );
  }

  /** Path part for operation `getDemoAccountDataHistoryAsync()` */
  static readonly GetDemoAccountDataHistoryAsyncPath = '/demo-account-data/{demoDataType}/history';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoAccountDataHistoryAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataHistoryAsync$Plain$Response(params: GetDemoAccountDataHistoryAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DemoAccountDataVersionCto>>> {
    return getDemoAccountDataHistoryAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoAccountDataHistoryAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataHistoryAsync$Plain(params: GetDemoAccountDataHistoryAsync$Plain$Params, context?: HttpContext): Observable<Array<DemoAccountDataVersionCto>> {
    return this.getDemoAccountDataHistoryAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DemoAccountDataVersionCto>>): Array<DemoAccountDataVersionCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoAccountDataHistoryAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataHistoryAsync$Json$Response(params: GetDemoAccountDataHistoryAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DemoAccountDataVersionCto>>> {
    return getDemoAccountDataHistoryAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoAccountDataHistoryAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataHistoryAsync$Json(params: GetDemoAccountDataHistoryAsync$Json$Params, context?: HttpContext): Observable<Array<DemoAccountDataVersionCto>> {
    return this.getDemoAccountDataHistoryAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<DemoAccountDataVersionCto>>): Array<DemoAccountDataVersionCto> => r.body)
    );
  }

  /** Path part for operation `getDemoAccountDataVersionAsync()` */
  static readonly GetDemoAccountDataVersionAsyncPath = '/demo-account-data/{demoDataType}/history/{documentId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoAccountDataVersionAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataVersionAsync$Plain$Response(params: GetDemoAccountDataVersionAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataCto>> {
    return getDemoAccountDataVersionAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoAccountDataVersionAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataVersionAsync$Plain(params: GetDemoAccountDataVersionAsync$Plain$Params, context?: HttpContext): Observable<DemoAccountDataCto> {
    return this.getDemoAccountDataVersionAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoAccountDataCto>): DemoAccountDataCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDemoAccountDataVersionAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataVersionAsync$Json$Response(params: GetDemoAccountDataVersionAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataCto>> {
    return getDemoAccountDataVersionAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDemoAccountDataVersionAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDemoAccountDataVersionAsync$Json(params: GetDemoAccountDataVersionAsync$Json$Params, context?: HttpContext): Observable<DemoAccountDataCto> {
    return this.getDemoAccountDataVersionAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoAccountDataCto>): DemoAccountDataCto => r.body)
    );
  }

  /** Path part for operation `restoreDemoAccountDataVersionAsync()` */
  static readonly RestoreDemoAccountDataVersionAsyncPath = '/demo-account-data/{demoDataType}/history/{documentId}/restore';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restoreDemoAccountDataVersionAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreDemoAccountDataVersionAsync$Plain$Response(params: RestoreDemoAccountDataVersionAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
    return restoreDemoAccountDataVersionAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restoreDemoAccountDataVersionAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreDemoAccountDataVersionAsync$Plain(params: RestoreDemoAccountDataVersionAsync$Plain$Params, context?: HttpContext): Observable<DemoDataPublishResultCto> {
    return this.restoreDemoAccountDataVersionAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoDataPublishResultCto>): DemoDataPublishResultCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `restoreDemoAccountDataVersionAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreDemoAccountDataVersionAsync$Json$Response(params: RestoreDemoAccountDataVersionAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
    return restoreDemoAccountDataVersionAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `restoreDemoAccountDataVersionAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  restoreDemoAccountDataVersionAsync$Json(params: RestoreDemoAccountDataVersionAsync$Json$Params, context?: HttpContext): Observable<DemoDataPublishResultCto> {
    return this.restoreDemoAccountDataVersionAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoDataPublishResultCto>): DemoDataPublishResultCto => r.body)
    );
  }

  /** Path part for operation `exportDemoAccountDataAsync()` */
  static readonly ExportDemoAccountDataAsyncPath = '/demo-account-data/{demoDataType}/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDemoAccountDataAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDemoAccountDataAsync$Plain$Response(params: ExportDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataExportCto>> {
    return exportDemoAccountDataAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDemoAccountDataAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDemoAccountDataAsync$Plain(params: ExportDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<DemoAccountDataExportCto> {
    return this.exportDemoAccountDataAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoAccountDataExportCto>): DemoAccountDataExportCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportDemoAccountDataAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDemoAccountDataAsync$Json$Response(params: ExportDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoAccountDataExportCto>> {
    return exportDemoAccountDataAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportDemoAccountDataAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportDemoAccountDataAsync$Json(params: ExportDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<DemoAccountDataExportCto> {
    return this.exportDemoAccountDataAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoAccountDataExportCto>): DemoAccountDataExportCto => r.body)
    );
  }

  /** Path part for operation `importDemoAccountDataAsync()` */
  static readonly ImportDemoAccountDataAsyncPath = '/demo-account-data/{demoDataType}/import';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importDemoAccountDataAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  importDemoAccountDataAsync$Plain$Response(params: ImportDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
    return importDemoAccountDataAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importDemoAccountDataAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  importDemoAccountDataAsync$Plain(params: ImportDemoAccountDataAsync$Plain$Params, context?: HttpContext): Observable<DemoDataPublishResultCto> {
    return this.importDemoAccountDataAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoDataPublishResultCto>): DemoDataPublishResultCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `importDemoAccountDataAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  importDemoAccountDataAsync$Json$Response(params: ImportDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
    return importDemoAccountDataAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `importDemoAccountDataAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  importDemoAccountDataAsync$Json(params: ImportDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<DemoDataPublishResultCto> {
    return this.importDemoAccountDataAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DemoDataPublishResultCto>): DemoDataPublishResultCto => r.body)
    );
  }

}
